import script from "./card-lead.vue?vue&type=script&setup=true&lang=js"
export * from "./card-lead.vue?vue&type=script&setup=true&lang=js"

import "./card-lead.vue?vue&type=style&index=0&id=97b60d5c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97b60d5c"]])

export default __exports__